exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab-budget[data-v-891b0a10] {\n  background-color: #ffffff;\n  border-radius: 2px;\n}\n", ""]);

// exports
